import React from 'react';
import { withStyles, createStyleSheet } from 'material-ui/styles';

import { Link } from 'react-router-dom';

import {
  Avatar,
  Card,
  CardContent,
  // CardActions,
  Typography,
} from 'components';

const styleSheet = createStyleSheet('StackCard', theme => ({
  card: {
    height: '100%',
  },
  title: {
    padding: theme.spacing.unit,
  },
  logo: {
    width: 80,
    height: 80,
    margin: '0 auto',
  },
  caption: {
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
  },
  inlineList: {
    display: 'flex',
    overflowX: 'scroll',
  },
  smallLogo: {
    width: 35,
    height: 35,
    marginRight: theme.spacing.unit,
  },
  buttonLabel: {
    flexDirection: 'column',
  },
  cardActions: {
    justifyContent: 'space-around',
    '> div': {
      flexDirection: 'column',
    },
  },
}));

const StackCard = ({ classes, name, slug, image, tools }) => {
  return (
    <Card className={classes.card}>
      <CardContent>
        <Link to={`/stack/${slug}`}>
          <Typography align="center" type="title" className={classes.title}>
            {name}
          </Typography>
          <Avatar
            alt={name}
            src={image && image.url}
            className={classes.logo}
          />
        </Link>

        <Typography type="caption" className={classes.caption}>
          Tools
        </Typography>

        <div className={classes.inlineList}>
          {tools &&
            tools.map(tool =>
              <Link to={`/tool/${tool.slug}`}>
                <Avatar
                  alt={tool.name}
                  src={tool.image && tool.image.url}
                  className={classes.smallLogo}
                />
              </Link>
            )}
        </div>
      </CardContent>
      {/*<CardActions className={classes.cardActions}>
        <IconButton>
          <span className={classes.buttonLabel}>
            <FavoriteIcon />
            <Typography type="caption">1,313</Typography>
          </span>
        </IconButton>
        <IconButton>
          <span className={classes.buttonLabel}>
            <FavoriteIcon />
            <Typography type="caption">1,313</Typography>
          </span>
        </IconButton>
        <IconButton>
          <span className={classes.buttonLabel}>
            <FavoriteIcon />
            <Typography type="caption">1,313</Typography>
          </span>
        </IconButton>
      </CardActions>*/}
    </Card>
  );
};

StackCard.defaultProps = {
  name: '',
  image: {},
};

export default withStyles(styleSheet)(StackCard);



// WEBPACK FOOTER //
// ./src/App/Stack/components/StackCard.js